module.exports = __webpack_public_path__ + "media/images/ui__themeToggleLight-dd08a42f0bcd368536e6b7025563b51d.png";